import api from './axiosInstance';

export const authApi = {
  login:          (body) => api.post('/auth/login', body).then(r => r.data),
  // Refresh token is an httpOnly cookie — browser sends it automatically.
  // No token in the request body or header needed.
  refresh:        ()     => api.post('/auth/refresh').then(r => r.data),
  logout:         ()     => api.post('/auth/logout').then(r => r.data),
  changePassword: (body) => api.post('/auth/change-password', body).then(r => r.data),
  // MFA
  mfaVerify:      (body) => api.post('/auth/mfa/verify', body).then(r => r.data),
  mfaSetup:       ()     => api.get('/auth/mfa/setup').then(r => r.data),
  mfaConfirm:     (body) => api.post('/auth/mfa/setup/confirm', body).then(r => r.data),
  mfaDisable:     (body) => api.delete('/auth/mfa/disable', { data: body }).then(r => r.data),
  mfaStatus:      ()     => api.get('/auth/mfa/status').then(r => r.data),
  mfaRegenCodes:  ()     => api.post('/auth/mfa/recovery-codes/regenerate').then(r => r.data),
};
